// react components
import React, {
    useEffect,
    useState,
} from 'react'
import moment from 'moment'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxModalStateSite,
} from 'data'

// pages
import {
    TemplateBlock797MultiDateFormModalSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    FormFieldSerializer,
} from 'serializers/site'

// props
type TemplateBlock797MultiDateSiteProps = {
    blockId: string
    deviceType: 'is-mobile' | 'is-tablet' | 'is-web'
    formInputObj: FormFieldSerializer | undefined
    format: 'date' | 'datetime' | 'time'
    handleInputChange: (name: string, value: any, label: string, stripe_field_type: string | undefined, stringValue?: string) => void
    isEditHovered: boolean
    reduxModalSite: reduxModalStateSite
    stylesNew: CustomCSSProperties | undefined
    tabIndex: number
    value: any
}

// main
export const TemplateBlock797MultiDateSite: React.FC<TemplateBlock797MultiDateSiteProps> = React.memo(({
    blockId,
    deviceType,
    formInputObj,
    format,
    handleInputChange,
    isEditHovered,
    reduxModalSite,
    stylesNew,
    tabIndex,
    value,
}) => {

    const dispatch = useDispatch()
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [multiDateData, setMultiDateData] = useState<{
        fid: number
        description?: string
        start_date?: string
        end_date?: string
    }[]>(value)
    const [dateId, setDateId] = useState<any>(undefined)

    useEffect(() => {
        if (!value) {
            setMultiDateData([])
        }
    }, [
        value,
    ])


    function onInputChange(e: any) {
        try {
            handleInputChange(formInputObj?.name!, e, formInputObj?.label!, formInputObj?.stripe_field_type)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock797MultiDateSite',
                'onInputChange',
            ))
        }
    }

    function handleInlineDelete(id: number) {
        try {
            const updatedData = multiDateData.filter(item => item.fid !== id)
            setMultiDateData(updatedData)
            onInputChange(updatedData)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock797MultiDateSite',
                'handleInlineDelete',
            ))
        }
    }

    return (
        <div className='template-block-797-multi-date'>
            <p
                className='mdi-add'
                onClick={() => setDateId('new')}
            >
                Ajouter d'autres dates
            </p>
            {multiDateData.length > 0 && (
                <div className='mdi-table-wrap'>
                    <table className='mdi-table'>
                        <tbody>
                            {multiDateData.map(item => (
                                <tr key={item.fid}>
                                    <td>
                                        {new Date(item.start_date!).toLocaleString('fr-FR', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </td>
                                    <td>
                                        {item.end_date ? new Date(item.end_date!).toLocaleString('fr-FR', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        }) : ''}
                                    </td>
                                    <td>
                                        <div className='mdi-action-wrap'>
                                            <div
                                                className='mdi-action'
                                                onClick={() => setDateId(item.fid)}
                                            >
                                                <i className='mo-new-icon-pencil-alt-solid mdi-action-icon' />
                                            </div>
                                            <div
                                                className='mdi-action'
                                                onClick={() => handleInlineDelete(item.fid)}
                                            >
                                                <i className='mo-new-icon-trash-solid mdi-action-icon' />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {dateId && (
                <TemplateBlock797MultiDateFormModalSite
                    defaultFields={{
                        sub_content_type: {
                            id: 85,
                            name: 85,
                        },
                    }}
                    multiDateData={multiDateData}
                    objectId={dateId}
                    onChange={onInputChange}
                    onCloseHelperModal={() => setDateId(false)}
                    setDateId={setDateId}
                    setMultiDateData={setMultiDateData}
                    stylesNew={stylesNew}
                />
            )}
        </div>
    )
})
